import { useReveal } from '@ccg/core';
import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import Text$1 from '../../basics/Text/Text.js';
import RevealBox$1 from '../RevealBox/RevealBox.js';
import StyledFacts from './Facts.style.js';

const Facts = ({
  alignment,
  facts
}) => {
  const [ref, isVisible] = useReveal();
  return /*#__PURE__*/React$1.createElement(StyledFacts, {
    hasRightAlignment: alignment === 'right',
    ref: ref
  }, facts.map(({
    id,
    fact
  }) => /*#__PURE__*/React$1.createElement(RevealBox$1, {
    key: id,
    className: "facts__fact",
    isVisible: isVisible
  }, /*#__PURE__*/React$1.createElement(Text$1, {
    content: fact
  }))));
};

Facts.propTypes = {
  alignment: PropTypes$1.oneOf(['right', 'left']),
  facts: PropTypes$1.arrayOf(PropTypes$1.shape({
    id: PropTypes$1.string,
    fact: PropTypes$1.string
  })).isRequired
};
Facts.defaultProps = {
  alignment: 'right'
};

export default Facts;
